var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},_vm._l((7),function(item,index){return _c('Shimmer',{key:index,staticClass:"rounded-pill mx-2 category",attrs:{"height":"40px","width":"180px"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }